import { BrandVariants, createDarkTheme, createLightTheme, Theme } from '@fluentui/react-components';

//
// The SkillControl brand ramp and the two themes built from it. Components read colours through Fluent's
// `tokens` (never a literal colour), so light and dark follow the provider in App/AppDesignSystem.tsx.
//
export const skillControlBrand: BrandVariants = {
  10: '#020305',
  20: '#111723',
  30: '#16263D',
  40: '#193253',
  50: '#1B3F6A',
  60: '#1B4C82',
  70: '#18599B',
  80: '#1267B4',
  90: '#3174C2',
  100: '#4F82C8',
  110: '#6790CF',
  120: '#7D9ED5',
  130: '#92ACDC',
  140: '#A6BAE2',
  150: '#BAC9E9',
  160: '#CDD8EF',
};

export const lightThemeV9: Theme = createLightTheme(skillControlBrand);

const darkThemeBase: Theme = createDarkTheme(skillControlBrand);

//the dark theme reads the brand a few steps lighter, so links and accents keep their contrast on dark surfaces
export const darkThemeV9: Theme = {
  ...darkThemeBase,
  colorBrandForeground1: skillControlBrand[110],
  colorBrandForeground2: skillControlBrand[120],
  colorBrandForegroundLink: skillControlBrand[120],
  colorBrandForegroundLinkHover: skillControlBrand[130],
};
